import { isJiraConnect } from '../utils/jiraContext'

// Backend API URL
// 
// Environment-specific configuration:
// 
// DEVELOPMENT:
//   - File: .env.development
//   - Default: empty string '' (goes through Vite proxy)
//   - Vite proxy forwards to http://localhost:9090
//   - This avoids CORS issues when app runs in Jira iframe
//
// UAT:
//   - File: .env.uat
//   - Set VITE_API_BASE_URL to your UAT backend URL
//   - Example: VITE_API_BASE_URL=https://api-uat.yourcompany.com
//   - Or empty string if backend is on same domain
//
// PRODUCTION:
//   - File: .env.production
//   - Set VITE_API_BASE_URL to your production backend URL
//   - Example: VITE_API_BASE_URL=https://api.yourcompany.com
//   - Or empty string if backend is on same domain
//
// Setup:
//   1. Copy .env.*.example files to .env.* (without .example)
//   2. Update VITE_API_BASE_URL in each .env file
//   3. Build with: npm run build:dev, build:uat, or build:prod
//
// No manual code changes needed - works automatically!
export const BASE_URL = import.meta.env.VITE_API_BASE_URL || ''

// Test Scenario ID (hardcoded for now - can be made dynamic later)
export const TEST_SCENARIO_ID = 1

// Default Jira Project ID for local development
export const DEFAULT_JIRA_PROJECT_ID = 10000

// Legacy export for backwards compatibility
export const JIRA_PROJECT_ID = DEFAULT_JIRA_PROJECT_ID

// ============================================================================
// ACTIVE PROJECT ID MANAGEMENT
// ============================================================================

/**
 * Module-level variable to store the active Jira project ID
 * This is set when the app initializes from Jira context
 * API functions use this instead of the hardcoded default
 */
let activeProjectId = DEFAULT_JIRA_PROJECT_ID

/**
 * Set the active Jira project ID
 * Called from App.jsx when Jira context is loaded
 *
 * @param {string|number} projectId - The project ID from Jira context
 */
export const setActiveProjectId = (projectId) => {
  if (projectId) {
    activeProjectId = projectId
    console.log('Active Project ID set to:', activeProjectId)
  }
}

/**
 * Get the active Jira project ID
 * Used by API functions to send the correct project ID to backend
 *
 * @returns {string|number} The active project ID
 */
export const getActiveProjectId = () => {
  return activeProjectId
}

/**
 * Get the current Jira Project ID
 *
 * In Jira Connect mode: Returns the project ID from Jira context
 * In standalone mode: Returns the hardcoded DEFAULT_JIRA_PROJECT_ID
 *
 * @param {string|null} contextProjectId - Project ID from Jira context (optional)
 * @returns {string|number} Project ID to use
 */
export const getProjectId = (contextProjectId = null) => {
  // If running in Jira Connect and context project ID is available, use it
  if (isJiraConnect() && contextProjectId) {
    return contextProjectId
  }

  // Otherwise, use the default hardcoded value
  return DEFAULT_JIRA_PROJECT_ID
}

/**
 * Check if running in development mode (standalone)
 * @returns {boolean}
 */
export const isDevelopmentMode = () => {
  return !isJiraConnect()
}
